import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import PhysicianInputForm from "../components/PhysicianInputForm";
import { resetStates } from "../../../actions/Common";
import { ApplicationState } from "../../../redux/ApplicationState";

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    any
  >
) => {
  return {
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
  };
};
export default connect(null, mapDispatchToProps)(PhysicianInputForm);
